"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const ListItem_1 = tslib_1.__importDefault(require("@mui/material/ListItem"));
const ArgusUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/ArgusUtils"));
const MenuLogo = ({ href, mini, large, label, open, ListItemProps }) => (react_1.default.createElement(ListItem_1.default, { component: "div", disableGutters: true, disablePadding: true, sx: { marginLeft: open ? 0 : -1, marginBottom: 1 }, ...ListItemProps },
    react_1.default.createElement(Box_1.default, { component: "a", href: ArgusUtils.toSpaUrl(href), sx: { height: "36px", margin: "auto" } },
        react_1.default.createElement(Box_1.default, { component: "img", sx: { height: "100%" }, alt: label, src: open ? large?.imgSrc : mini?.imgSrc }))));
exports.default = MenuLogo;
